import TrailTile from './TrailTile';

export default TrailTile;
